import { withChartLayout } from 'components/common';
import SavedInjections from 'components/features/chart/injections/saved-injections/SavedInjections';

const SavedInjectionsPage = withChartLayout('Saved Injections Charting')(SavedInjections);
export default SavedInjectionsPage;
